//libs
import React from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {toast} from "react-toastify";

// components
import axios from "../../../axios-defaults";

const PermissionCarProducts = (props) => {
    const { t } = useTranslation();

    const {subAccountName, subAccountCode, representative, accountCode} = props.subAccount;
    const checked = props.checked;
    const checkedStatus = checked ? 'enabled' : 'disabled';
    const { register, handleSubmit } = useForm();

    const submitHandler = async submitData => {
		const {isCardlockProductOnly} = submitData;
		submitData.isCardlockProductOnly = Boolean(isCardlockProductOnly);

        axios.patch(`/subAccounts/updateSubAccount`, submitData)
            .then(response => {
                toast.success(
                    <div>
                        <i className="fas fa-lock"></i>&nbsp;&nbsp;{t('account.cards.permission_car_products.success')}
                    </div>
                );
                props.closeModalSuccess();
            }).catch(error => {
				toast.error(
					<div>
						 <i className="fal fa-exclamation-circle"></i>&nbsp;{error.message}
					 </div>
				);
				console.log('[PermissionCarProducts.js] : Ajax error in submitHandler()',error.message);
		});
    }

    return (
        <div className="cardmanager">
            <div className="cardmanager__upper">
                <div className="cardmanager__upper__main">
                    <strong className="cardmanager__upper__subtitle h3 m-0">
                        {subAccountName}
                    </strong>
                    <h3 className="cardmanager__upper__title headline headline--main">
                        {`#${subAccountCode}`}
                    </h3>
                </div>
                <div className="cardmanager__upper__meta">
                    <p className="cardmanager__upper__meta__item m-0">
                        {t("account.cards.representative_label")}
                    </p>
                    <strong className="cardmanager__upper__meta__item">
                       {representative}
                    </strong>
                </div>
            </div>

            <strong className="d-block strong strong--block strong--c-red strong--margin--20">
                {t(`account.cards.permission_car_products.text_danger`)}
            </strong>

            <p>{t(`account.cards.permission_car_products.text`)}</p>

            <div className="message message--info mt-5">
                <div className="message__icon">
                    <i className="fas fa-clock"></i>
                </div>
                <div className="message__content">
                    <div>
                        {t('account.cards.permission_car_products.notice')}
                    </div>
                </div>
            </div>

            <form className="form mt-4" onSubmit={handleSubmit(submitHandler)} method="post">
                <fieldset className="fieldset form__actions">
                    <button className="btn btn--outline btn--outline--gray action" onClick={props.closeModal}>
                        <span className="btn__text">
                            { t('account.cards.management.buttons.cancel') }
                        </span>
                    </button>
                    <button type="submit" className="btn btn--raised btn--raised--red action">
                        <span className="btn__text">
                            {t(`account.cards.permission_car_products.${checkedStatus}.confirm`)}
                        </span>
                    </button>
                </fieldset>
                <input type="hidden" value={subAccountCode} {...register("subAccountCode")} />
                <input type="hidden" value={checked} {...register("isCardlockProductOnly")} />
            </form>
        </div>

    );
};

export default PermissionCarProducts;
